export var DeviceType;
(function (DeviceType) {
    DeviceType["mobile"] = "mobile";
    DeviceType["tablet"] = "tablet";
    // For web, desktop means a browser on PC/MAC/Linux, etc
    // Basically anything non-mobile, non-tablet.
    // Not desktop app.
    DeviceType["desktop"] = "desktop";
})(DeviceType || (DeviceType = {}));
/**
 * This are events related to preview lifecycle events. We don't want two events of same type to occur in succession. So only
 * events related to previews lifecycle will come here. For other event types, define them below in EventType
 */
export var SessionEventType;
(function (SessionEventType) {
    SessionEventType["FilePreviewSessionEnded"] = "preview_session_ended";
    SessionEventType["FilePreviewAttemptStarted"] = "preview_attempted";
    SessionEventType["FilePreviewSupportConfirmed"] = "support_confirmed";
    SessionEventType["FilePreviewSupportDenied"] = "support_denied";
    SessionEventType["FilePreviewDownloadAttempted"] = "download_attempted";
    SessionEventType["FilePreviewDownloadSucceeded"] = "download_succeeded";
    SessionEventType["FilePreviewDownloadFailed"] = "download_failed";
    SessionEventType["FilePreviewRenderSucceeded"] = "render_succeeded";
    SessionEventType["FilePreviewRenderFailed"] = "render_failed";
    SessionEventType["LifecycleFailure"] = "lifecycle_failure";
})(SessionEventType || (SessionEventType = {}));
// Actions on this list must be added to the Python FilePreviewEvent enum in metaserver/logger/FilePreviewLogger.py
export var EventType;
(function (EventType) {
    EventType["UserAction"] = "user_action";
    // Event logged if the user stays in file preview 3 seconds after the preview render rendered successfully.
    EventType["UserEngaged3SecondsAfterRenderSucceeded"] = "user_engaged_3_seconds_after_render_succeeded";
    // Use this to log events that aren't user-triggered but aren't core actions that should be special-handled in Python
    EventType["Background"] = "background";
})(EventType || (EventType = {}));
/**
 *  Keep in sync with server-side counterpart in FilePreviewLogger.py
 *  Refer to metaserver/lib/file_viewer/constants.py for documentation on what each variant means
 */
export var SourceContext;
(function (SourceContext) {
    SourceContext["Browse"] = "browse";
    SourceContext["Home"] = "home";
    SourceContext["ContentSuggestions"] = "content_suggestions";
    SourceContext["SharedLinkFile"] = "sl_file";
    SourceContext["SharedLinkFolder"] = "sl_folder";
    SourceContext["SharedLinkCollection"] = "sl_collection";
    SourceContext["VersionHistory"] = "version_history";
    SourceContext["FileViewer"] = "file_viewer";
    SourceContext["Desktop"] = "desktop";
    SourceContext["EmbeddedSharedLinkFile"] = "embedded_sl_file";
    SourceContext["ArchiveFile"] = "archive_file";
    SourceContext["Workflow"] = "workflow";
    SourceContext["TrelloPreview"] = "trello_preview";
    SourceContext["FileLocking"] = "file_locking";
    SourceContext["Search"] = "search";
    SourceContext["Recents"] = "recents";
    SourceContext["Starred"] = "starred";
    SourceContext["StandalonePreview"] = "standalone_preview";
    SourceContext["Photos"] = "photos";
    SourceContext["Collections"] = "collections";
    SourceContext["HelloSign"] = "hellosign";
    SourceContext["Transfer"] = "transfer";
    SourceContext["Dropin"] = "dropin";
    SourceContext["Backup"] = "backup";
    SourceContext["PdfEditor"] = "pdf_editor";
    SourceContext["CollabBrowse"] = "collab_browse";
    SourceContext["DesktopCommentNotification"] = "desktop_comment_notification";
    SourceContext["DesktopDetailsPaneMenu"] = "desktop_details_pane_menu";
    SourceContext["DesktopPreviewPane"] = "desktop_preview_pane";
    SourceContext["DesktopTray"] = "desktop_tray";
    SourceContext["DesktopTrayPopoverExpand"] = "desktop_tray_popover_expand";
    SourceContext["DesktopTrayContextMenu"] = "desktop_tray_context_menu";
    SourceContext["Unknown"] = "unknown";
    SourceContext["QuickViewBrowse"] = "quick_view_browse";
    SourceContext["QuickViewSearch"] = "quick_view_search";
    SourceContext["DesktopPreview"] = "desktop_preview";
    SourceContext["FssDesktopPreview"] = "fss_desktop_preview";
    SourceContext["EdisonDesktopPreview"] = "edison_desktop_preview";
    SourceContext["FileUploaderPreviewFile"] = "file_uploader_preview_file";
    SourceContext["UngatedEditor"] = "ungated_editor";
    SourceContext["FileChooser"] = "file_chooser";
    SourceContext["DesktopLauncherESV"] = "desktop_launcher_esv";
})(SourceContext || (SourceContext = {}));
/*
 * No need to log separately if in USER_ACTION_MAP
 */
export var UserAction;
(function (UserAction) {
    UserAction["ArchiveNavigation"] = "archive_navigation";
    UserAction["ChangePlaybackPosition"] = "change_playback_position";
    UserAction["ClickDropboxLogo"] = "click_dropbox_logo";
    UserAction["ClosedCaptionsUnavailable"] = "cc_unavailable";
    UserAction["CloseDocSidebar"] = "close_doc_sidebar";
    UserAction["CloseViewer"] = "close";
    UserAction["CloseMobileMenu"] = "close_mobile_menu";
    UserAction["Comment"] = "comment";
    UserAction["CopyLink"] = "copy_link";
    UserAction["Delete"] = "delete";
    UserAction["DeleteStart"] = "delete_start";
    UserAction["DeleteCancel"] = "delete_cancel";
    UserAction["DeleteSuccess"] = "delete_success";
    UserAction["DeleteFailed"] = "delete_failure";
    UserAction["DeleteFailedNoPermission"] = "delete_failure_no_permission";
    UserAction["Rename"] = "rename";
    UserAction["RenameStart"] = "rename_start";
    UserAction["RenameSuccess"] = "rename_success";
    UserAction["RenameFailed"] = "rename_failure";
    UserAction["DownloadStart"] = "download_start";
    UserAction["DownloadFailed"] = "download_failed";
    UserAction["DownloadSuccess"] = "download_success";
    UserAction["FindInDocStart"] = "find_click";
    UserAction["FindInDocNext"] = "find_next";
    UserAction["FindInDocPrev"] = "find_prev";
    UserAction["FindInDocEnd"] = "find_exit";
    UserAction["FlipNext"] = "flip_next";
    UserAction["FlipPrevious"] = "flip_prev";
    UserAction["FlipNextSlideshow"] = "flip_next_slideshow";
    UserAction["FlipPreviousSlideshow"] = "flip_prev_slideshow";
    UserAction["HideLineNumbers"] = "hide_line_numbers";
    UserAction["ShowLineNumbers"] = "show_line_numbers";
    UserAction["OpenDocSidebar"] = "open_doc_sidebar";
    UserAction["OpenFullscreenPreview"] = "open_fullscreen_preview";
    UserAction["OpenIn"] = "open_in";
    UserAction["OpenInMenu"] = "open_in_menu";
    UserAction["OpenMobileMenu"] = "open_mobile_menu";
    UserAction["OpenSendForSignature"] = "open_send_for_signature";
    UserAction["OpenVersionHistory"] = "open_version_history";
    UserAction["OpenWebPreview"] = "open_web_preview";
    UserAction["OpenWithImageEditor"] = "open_with_image_editor";
    UserAction["OpenWithPDFEditor"] = "open_with_pdf_editor";
    UserAction["OpenWith"] = "open_with";
    UserAction["PageDown"] = "page_down";
    UserAction["PageJump"] = "page_jump";
    UserAction["PageUp"] = "page_up";
    UserAction["Print"] = "print";
    UserAction["Restore"] = "restore";
    UserAction["SaveToDropbox"] = "save_to_dropbox";
    UserAction["SaveToDropboxApprove"] = "save_to_dropbox_approve";
    UserAction["SaveToDropboxCancel"] = "save_to_dropbox_cancel";
    UserAction["OpenSaveAs"] = "open_save_as";
    UserAction["SelectSaveAs"] = "save_as";
    UserAction["SelectSidebarPage"] = "select_sidebar_page";
    UserAction["OpenSignMenu"] = "open_sign_menu";
    UserAction["SendAndTrack"] = "send_and_track";
    UserAction["SendForReview"] = "send_for_review";
    UserAction["SendForSignature"] = "send_for_signature";
    UserAction["SelfSign"] = "self_sign";
    UserAction["Share"] = "share";
    UserAction["ShareMenu"] = "share_menu";
    UserAction["ShareToAction"] = "share_to_action";
    UserAction["ShareWithAnalytics"] = "share_with_analytics";
    UserAction["OpenMoreApps"] = "open_more_apps";
    UserAction["SendACopy"] = "send_a_copy";
    UserAction["Star"] = "star";
    UserAction["SidebarPaneSelected"] = "sidebar_pane_selected";
    UserAction["ClosedCaptionsClick"] = "cc_toggle_click";
    UserAction["ClosedCaptionsClickSuccess"] = "cc_toggle_success";
    UserAction["ToggleClosedCaptions"] = "cc_track_toggle";
    UserAction["ToggleFullscreenOff"] = "full_screen_toggle_off";
    UserAction["ToggleFullscreenOn"] = "full_screen_toggle_on";
    UserAction["ToggleSlideshowOn"] = "slideshow_toggle_on";
    UserAction["ToggleSlideshowOff"] = "slideshow_toggle_off";
    UserAction["Unstar"] = "unstar";
    UserAction["EditPdf"] = "edit_pdf";
    UserAction["EditImage"] = "edit_image";
    UserAction["EditVideo"] = "edit_video";
    UserAction["Draw"] = "draw";
    UserAction["Highlight"] = "highlight";
    UserAction["AddText"] = "add_text";
    UserAction["EditPdfText"] = "edit_pdf_text";
    UserAction["EditVideoCancel"] = "edit_video_cancel";
    UserAction["EditVideoSaveCopyClicked"] = "edit_video_save_a_copy_clicked";
    UserAction["EditVideoReplaceOriginalClicked"] = "edit_video_replace_original_clicked";
    UserAction["EditVideoSaveCopyCancel"] = "edit_video_save_copy_cancel";
    UserAction["EditVideoReplaceOriginalCancel"] = "edit_video_replace_original_cancel";
    UserAction["EditVideoSaveCopyConfirmed"] = "edit_video_save_a_copy_confirmed";
    UserAction["EditVideoReplaceOriginalConfirmed"] = "edit_video_replace_original_confirmed";
    UserAction["AudioTrackChanged"] = "audio_track_changed";
    UserAction["AudioTrackSubmenuOpened"] = "audio_track_submenu_opened";
    UserAction["EmbedAudioTrackSubmenuOpened"] = "embed_audio_track_submenu_opened";
    UserAction["EmbedAudioTrackChanged"] = "embed_audio_track_changed";
    UserAction["VideoPlaybackRateChanged"] = "playback_rate_changed";
    UserAction["OpenFileMenu"] = "open_file_menu";
    UserAction["OpenEditMenu"] = "open_edit_menu";
    UserAction["OpenViewMenu"] = "open_view_menu";
    UserAction["OpenHelpMenu"] = "open_help_menu";
    UserAction["AddToCollection"] = "add_to_collection";
    UserAction["FileActivity"] = "file_activity";
    UserAction["FileActivityHide"] = "hide_file_activity";
    UserAction["HelpCenter"] = "help_center";
    UserAction["HelpAndResources"] = "help_and_resources";
    UserAction["PrivacyLegal"] = "privacy_and_legal";
    UserAction["CookieCCPA"] = "cookie_and_ccpa_preferences";
    UserAction["ReportIssue"] = "report_an_issue";
    UserAction["OpenActivityFilterMenu"] = "activity_filter_menu";
    UserAction["AddActivityFilter"] = "add_activity_filter";
    UserAction["ImageFilter"] = "image_filter";
    UserAction["Filter"] = "filter";
    UserAction["FilterSelectAll"] = "filter_select_all";
    UserAction["FilterClearAll"] = "filter_clear_all";
    UserAction["ConvertFile"] = "convert_file";
    UserAction["DecompressFile"] = "decompress_file";
    UserAction["ExtractAll"] = "extract_all";
    UserAction["SaveACopy"] = "save_a_copy";
    UserAction["ReplaceOriginal"] = "replace_original";
    UserAction["OpenEditDropdown"] = "open_edit_dropdown";
    UserAction["OpenMarkUpDropdown"] = "open_mark_up_dropdown";
    // TODO: rename these to not have 'video' in the name
    UserAction["EditVideoDiscardChangesClicked"] = "discard_edit_clicked";
    UserAction["EditVideoDiscardChangesConfirmed"] = "discard_edit_confirmed";
    UserAction["EditVideoDiscardChangesCancel"] = "discard_edit_cancel";
    UserAction["EditVideoNewFolderAttempt"] = "new_folder_attempt";
    UserAction["EditVideoNewFolderConfirm"] = "new_folder_confirm";
    UserAction["EditVideoNewFolderSuccess"] = "new_folder_success";
    UserAction["EditVideoNewFolderFailure"] = "new_folder_failure";
    UserAction["EditVideoNewFolderCancel"] = "new_folder_cancel";
    UserAction["EditVideoUndo"] = "edit_video_undo";
    UserAction["EditVideoRedo"] = "edit_video_redo";
    UserAction["EditVideoAttempt"] = "edit_video_attempt";
    UserAction["EditVideoFailure"] = "edit_video_failure";
    // todo: consolidate the video-edit specific logs into these
    UserAction["EditCancel"] = "edit_cancel";
    UserAction["EditSaveCopyClicked"] = "edit_save_a_copy_clicked";
    UserAction["EditReplaceOriginalClicked"] = "edit_replace_original_clicked";
    UserAction["EditSaveCopyCancel"] = "edit_save_copy_cancel";
    UserAction["EditReplaceOriginalCancel"] = "edit_replace_original_cancel";
    UserAction["EditSaveCopyConfirmed"] = "edit_save_a_copy_confirmed";
    UserAction["EditReplaceOriginalConfirmed"] = "edit_replace_original_confirmed";
    UserAction["EditAttempt"] = "edit_attempt";
    UserAction["EditFailure"] = "edit_failure";
    UserAction["EditSuccess"] = "edit_success";
    UserAction["EditError"] = "edit_error";
    UserAction["EditStart"] = "edit_start";
    UserAction["VersionHistory"] = "version_history";
    UserAction["ZoomIn"] = "zoom_in";
    UserAction["ZoomToggleOriginalOrFit"] = "zoom_toggle_original_or_fit";
    UserAction["ZoomOut"] = "zoom_out";
    UserAction["ZoomFitToWidth"] = "fit_to_width";
    UserAction["ZoomFitToPage"] = "fit_to_page";
    UserAction["ZoomChangePercentage"] = "change_zoom_percentage";
    UserAction["OpenActionBarOverflow"] = "open_action_bar_overflow";
    UserAction["GoToFolder"] = "go_to_folder_click";
    UserAction["AudioVideoSettingsMenuOpened"] = "audio_video_settings_menu_opened";
    UserAction["PlaybackRateSubmenuOpened"] = "playbackback_rate_submenu_opened";
    UserAction["QualitySettingsSubmenuOpened"] = "quality_settings_submenu_opened";
    UserAction["SetVolume"] = "set_volume";
    UserAction["SetMuted"] = "set_muted";
    UserAction["SetUnmuted"] = "set_unmuted";
    UserAction["AudioVideoSeeking"] = "audio_video_seeking";
    UserAction["AudioVideoSeeked"] = "audio_video_seeked";
    UserAction["ChangeSpeed"] = "change_speed";
    UserAction["Repeat"] = "repeat";
    UserAction["Rotate"] = "rotate";
    UserAction["RotateLeft"] = "rotate_left";
    UserAction["RotateRight"] = "rotate_right";
    UserAction["Flip"] = "flip";
    UserAction["FlipHorizontal"] = "flip_horizontal";
    UserAction["FlipVertical"] = "flip_vertical";
    UserAction["Crop"] = "crop";
    UserAction["Adjust"] = "adjust";
    UserAction["AdjustTrim"] = "adjust_trim";
    UserAction["AdjustCrop"] = "adjust_crop";
    UserAction["Trim"] = "trim";
    UserAction["Enhance"] = "enhance";
    UserAction["ChangeTextEncoding"] = "change_text_encoding";
    UserAction["TranscriptShow"] = "transcript";
    UserAction["TranscriptHide"] = "hide_transcript";
    UserAction["TranscriptCopyAllClick"] = "transcript_copy_all";
    UserAction["TranscriptSearchAttempt"] = "transcript_search_attempt";
    UserAction["TranscriptJumpToTimestamp"] = "transcript_jump_to_timestamp";
    UserAction["TranscriptLoadSuccess"] = "transcript_load_success";
    UserAction["TranscriptLoadFailure"] = "transcript_load_failure";
    UserAction["TranscriptCopySegmentClick"] = "transcript_copy_segment";
    UserAction["EditTranscript"] = "edit_transcript";
    UserAction["SaveEditTranscript"] = "save_edit_transcript";
    UserAction["CancelEditTranscript"] = "cancel_edit_transcript";
    UserAction["EditTranscriptTimer"] = "edit_transcript_timer";
    UserAction["TranscriptFeedbackSubmitted"] = "transcript_feedback_submitted";
    UserAction["LoggedOutRotateLeft"] = "logged_out_rotate_left";
    UserAction["LoggedOutRotateRight"] = "logged_out_rotate_right";
    UserAction["LoggedOutFlipHorizontal"] = "logged_out_flip_horizontal";
    UserAction["LoggedOutFlipVertical"] = "logged_out_flip_vertical";
    UserAction["LoggedOutCrop"] = "logged_out_crop";
    UserAction["LoggedOutAdjust"] = "logged_out_adjust";
    UserAction["LoggedOutTrim"] = "logged_out_trim";
    UserAction["Watermark"] = "watermark";
    UserAction["ShowComments"] = "show_comments";
    UserAction["HideComments"] = "hide_comments";
    UserAction["Info"] = "info";
    UserAction["InfoHide"] = "hide_info";
    UserAction["AddTag"] = "add_tag";
    UserAction["RemoveTag"] = "remove_tag";
    UserAction["SelectTag"] = "select_tag";
    UserAction["InfoShowMoreMetadata"] = "show_all_metadata";
    UserAction["InfoHideMoreMetadata"] = "hide_all_metadata";
    // Dropbox AI events
    // Some constant names don't match the string values, this is intended so that the string value remains the same as
    // the existing legacy events
    UserAction["DropboxAI"] = "dropbox_ai";
    UserAction["AutoOpenDropboxAI"] = "auto_open_dropbox_ai";
    UserAction["ShownDropboxAI"] = "ai_blade_render";
    UserAction["HideDropboxAI"] = "ai_blade_hide";
    UserAction["CreateDropboxAIQuery"] = "create_dropbox_ai_query";
    UserAction["SelectDropboxAIShowSources"] = "ai_blade_click_show_sources";
    UserAction["SelectDropboxAIHideSources"] = "ai_blade_click_hide_sources";
    UserAction["SelectDropboxAISummarizeStart"] = "ai_blade_start_summary";
    UserAction["SelectDropboxAISummarizeSuccess"] = "ai_blade_get_summary_success";
    UserAction["SelectDropboxAIHelpCenter"] = "select_dropbox_ai_help_center";
    UserAction["SelectDropboxAIGiveFeedback"] = "select_dropbox_ai_give_feedback";
    UserAction["SelectDropboxAIAskStart"] = "ai_blade_start_query";
    UserAction["SelectDropboxAIAskSuccess"] = "ai_blade_get_answer_success";
    UserAction["SelectDropboxAIPageNavigation"] = "select_dropbox_ai_page_navigation";
    UserAction["SelectDropboxAIVideoSeek"] = "select_dropbox_ai_video_seek";
    UserAction["SelectDropboxAIConsentAllow"] = "ai_blade_consent_allow";
    UserAction["SelectDropboxAIConsentCancel"] = "ai_blade_consent_cancel";
    UserAction["ShownDropboxAIConsentModal"] = "shown_dropbox_ai_consent_modal";
    UserAction["CopyDropboxAIAnswer"] = "ai_blade_copy_answer";
    UserAction["ClearDropboxAIQuery"] = "ai_blade_clear_query";
    UserAction["EditImageAttempt"] = "edit_image_attempt";
    UserAction["LoggedOutEditImageAttempt"] = "logged_out_edit_image_attempt";
    UserAction["LoggedOutEditPdfAttempt"] = "logged_out_edit_pdf_attempt";
    UserAction["LoggedOutEditAudioVideoAttempt"] = "logged_out_edit_audio_video_attempt";
    UserAction["EditText"] = "edit_text";
    // Open in app header and mobile interstitial events
    UserAction["AppDownloadInterstitialClose"] = "app_download_interstitial_close";
    UserAction["AppDownloadInterstitialContinue"] = "app_download_interstitial_continue";
    UserAction["AppDownloadInterstitialInstall"] = "app_download_interstitial_install";
    UserAction["AppDownloadInterstitialView"] = "app_download_interstitial_view";
    UserAction["OpenInAppBannerClose"] = "open_in_app_banner_close";
    UserAction["OpenInApp"] = "open_in_app";
    // EXPERIMENT START (maxim, liangela): sharing_receiver_quick_react
    UserAction["ShowCommentsSideBar"] = "SHOW_COMMENTS_SIDEBAR";
    UserAction["ShowQuickReactBar"] = "SHOW_QUICK_REACT_BAR";
    UserAction["ClickQuickReact"] = "CLICK_QUICK_REACT";
    UserAction["ClickQuickReactSticker"] = "CLICK_QUICK_REACT_STICKER";
    UserAction["PostQuickReact"] = "POST_QUICK_REACT";
    UserAction["DeleteQuickReact"] = "DELETE_QUICK_REACT";
    UserAction["ViewAuthPage"] = "VIEW_AUTH_PAGE";
    // EXPERIMENT END (maxim, liangela): sharing_receiver_quick_react
    UserAction["Copy"] = "copy";
    UserAction["Move"] = "move";
    UserAction["Download"] = "download";
    UserAction["Unzip"] = "unzip";
    UserAction["PinTo"] = "pin_to";
    UserAction["HideTools"] = "hide_tools";
    UserAction["ShowTools"] = "show_tools";
    UserAction["VideoEdit"] = "video_edit";
    UserAction["Upscale"] = "upscale";
    UserAction["AutoStraighten"] = "auto_straighten";
    UserAction["ColorCorrect"] = "color_correct";
    UserAction["Search"] = "search";
    UserAction["PageSelector"] = "page_selector";
    UserAction["HidePageSelector"] = "hide_page_selector";
    UserAction["Continue"] = "continue";
    UserAction["Cancel"] = "cancel";
    UserAction["ReportToDropbox"] = "report_to_dropbox";
    UserAction["ShowLinkWarningModal"] = "show_link_warning_modal";
    UserAction["CheckFileAccess"] = "check_file_access";
    UserAction["SwipeToolbar"] = "swipe_toolbar";
    UserAction["WebShare"] = "web_share";
    UserAction["CompareFile"] = "compare_file";
    UserAction["MotionPhotoRequestPlay"] = "motion_photo_request_play";
    UserAction["MotionPhotoReady"] = "motion_photo_ready";
    UserAction["SlideshowPlay"] = "slideshow_play";
    UserAction["SlideshowPause"] = "slideshow_pause";
    UserAction["SlideshowDurationDropdownOpened"] = "slideshow_duration_dropdown_opened";
    UserAction["SlideshowDurationChanged"] = "slideshow_duration_changed";
    UserAction["WebToMobile"] = "web_to_mobile";
    // EXPERIMENT START (calvinlee): previews_open_in_m2
    UserAction["ShowDesktopModal"] = "show_desktop_modal";
    UserAction["ShowDesktopInstallTooltip"] = "show_desktop_install_tooltip";
    UserAction["ShowDesktopOpenInTooltip"] = "show_desktop_open_in_tooltip";
    UserAction["DesktopModalContinueDownload"] = "desktop_modal_continue_download";
    UserAction["DesktopModalOpenInClicked"] = "desktop_modal_open_in_clicked";
    UserAction["DesktopModalDoNotShowAgain"] = "desktop_modal_do_not_show_again";
    UserAction["DesktopModalClose"] = "desktop_modal_close";
    UserAction["DesktopInstallTooltipInstallClicked"] = "desktop_install_tooltip_install_clicked";
    UserAction["DesktopInstallTooltipClose"] = "desktop_install_tooltip_close";
    UserAction["DesktopOpenInTooltipFinderClicked"] = "desktop_open_in_tooltip_finder_clicked";
    UserAction["DesktopOpenInToolTipClose"] = "desktop_open_in_tooltip_close";
    // EXPERIMENT END (calvinlee): previews_open_in_m2
})(UserAction || (UserAction = {}));
export var BackgroundEvent;
(function (BackgroundEvent) {
    BackgroundEvent["DocPageLoad"] = "doc_page_load";
    BackgroundEvent["InvalidLoggingOrder"] = "invalid_logging_order";
})(BackgroundEvent || (BackgroundEvent = {}));
export var DocPageLoadState;
(function (DocPageLoadState) {
    DocPageLoadState["Loaded"] = "loaded";
    DocPageLoadState["Error"] = "error";
})(DocPageLoadState || (DocPageLoadState = {}));
// All new UserActionContext values must be added to
// dropbox/heracles/apps/self_serve_analytics/pap_enrichment/action_element_allowlist.txt.
// See https://dropbox.atlassian.net/wiki/spaces/PAP/pages/1093468269/Action+Element+Sanitization.
export var UserActionContext;
(function (UserActionContext) {
    // Used for initialization
    UserActionContext["Default"] = "";
    UserActionContext["Toolbar"] = "toolbar";
    UserActionContext["DocSidebar"] = "doc_sidebar";
    UserActionContext["LeftRail"] = "left_rail";
    UserActionContext["MouseWheel"] = "mouse_wheel";
    // When pdf file change, we reset the page index
    UserActionContext["DocReset"] = "doc_reset";
    // When a link node is clicked on pdf
    UserActionContext["DocLink"] = "doc_link";
    // When the user interacts with the preview surface
    UserActionContext["SurfaceGesture"] = "surface_gesture";
    UserActionContext["PreviewError"] = "preview_error";
    // From the Title bar (ported from Metaserver)
    UserActionContext["TitleBarMain"] = "title_bar_main";
    // When we initialize FV
    UserActionContext["Initialization"] = "initialization";
    // When a user calls a keyboard shortcut
    UserActionContext["Keyboard"] = "keyboard";
    // When the user clicks on the preview content main eg archive navigation
    UserActionContext["PreviewContentMain"] = "preview_content_main";
    // When the user clicks on snackbars
    UserActionContext["Snackbar"] = "Snackbar";
    UserActionContext["FindInDocSearchbar"] = "find_in_doc_searchbar";
    UserActionContext["PreviewTopNav"] = "preview_top_nav";
    UserActionContext["SplitShare"] = "split_share";
    UserActionContext["MobileWebFooter"] = "mobile_web_footer";
    UserActionContext["MobileWebFooterLoggedOut"] = "mobile_web_footer_logged_out";
    UserActionContext["MobileWebMeatball"] = "mobile_web_meatball";
    UserActionContext["MobileWebMeatballLoggedOut"] = "mobile_web_meatball_logged_out";
    UserActionContext["VideoEditing"] = "video_editing";
    UserActionContext["VideoEditingFileViewerToolbar"] = "preview_file_viewer_toolbar";
    UserActionContext["PostDownloadEditModal"] = "post_download_edit_modal";
    UserActionContext["Editor"] = "editor";
    UserActionContext["TextEditing"] = "text_editing";
    UserActionContext["PreviewTitlebar"] = "preview_titlebar";
    UserActionContext["PreviewSidebar"] = "preview_sidebar";
    UserActionContext["PreviewToolbar"] = "preview_toolbar";
    UserActionContext["PreviewToolbarOverflowMenu"] = "preview_toolbar_overflow_menu";
    UserActionContext["EditToolbar"] = "edit_toolbar";
    UserActionContext["EditTimeline"] = "edit_timeline";
    UserActionContext["EditVideoWindow"] = "edit_video_window";
    // From the left or right Sidebar
    UserActionContext["Sidebar"] = "sidebar";
    UserActionContext["AppDownloadInterstitial"] = "app_download_interstitial";
    UserActionContext["OpenInAppBanner"] = "open_in_app_banner";
    UserActionContext["TextHighlightMenu"] = "text_highlight_menu";
    UserActionContext["QuickReact"] = "quick_react";
    // quick_view
    UserActionContext["QuickViewToolbar"] = "quick_view_toolbar";
    UserActionContext["QuickViewFloatingToolbar"] = "quick_view_floating_toolbar";
    UserActionContext["QuickViewOverflowMenu"] = "quick_view_overflow_menu";
    UserActionContext["QuickViewTitlebar"] = "quick_view_titlebar";
    UserActionContext["QuickViewCommentPlugin"] = "quick_view_comment_plugin";
    UserActionContext["HelpMenu"] = "help_menu";
    UserActionContext["ViewMenu"] = "view_menu";
    UserActionContext["FileMenu"] = "file_menu";
    UserActionContext["EditMenu"] = "edit_menu";
    // Actions started automatically based on user preferences. For example, opening a sidebar because it was open in
    // the last session.
    UserActionContext["UserPreference"] = "user_preference";
    UserActionContext["Modal"] = "modal";
    // comments
    UserActionContext["UnreadComments"] = "unread_comments";
    UserActionContext["LoggedOutCommenting"] = "logged_out_commenting";
    // file compare page
    UserActionContext["FileComparePage"] = "file_compare_page";
    //toolbar
    UserActionContext["SignDropdown"] = "sign_dropdown";
    UserActionContext["EditFileDropdown"] = "edit_dropdown";
    UserActionContext["MarkUpDropdown"] = "mark_up_dropdown";
    UserActionContext["EnhanceSubmenu"] = "enhance_submenu";
    //slideshow
    UserActionContext["Slideshow"] = "slideshow";
    // Action initiated in the mobile app that carries over to web/desktop preview
    UserActionContext["MobileAppToWebPreview"] = "mobile_app_to_web_preview";
})(UserActionContext || (UserActionContext = {}));
/*
 * Timer/mark labels for previews performance metrics
 */
export var PreviewsTimer;
(function (PreviewsTimer) {
    PreviewsTimer["VideoEditorOpen"] = "previews_fvsdk_video_editor_open_ms";
    PreviewsTimer["SidebarContentsMount"] = "previews_sidebar_contents_mount_ms";
})(PreviewsTimer || (PreviewsTimer = {}));
export const PREVIEW_TTVC_DURATION_EVENT = 'visually_complete';
export const maybeMapToPreviewTitlebar = (actionElement) => {
    if (actionElement === UserActionContext.HelpMenu ||
        actionElement === UserActionContext.ViewMenu ||
        actionElement === UserActionContext.FileMenu ||
        actionElement === UserActionContext.EditMenu) {
        return UserActionContext.PreviewTitlebar;
    }
    return actionElement;
};
//# sourceMappingURL=constants.preenvesnextjs.map
